import React, { useEffect, useState } from 'react';
import './raiseBox.css';
import { Button } from './Button';
import { CaretakersService } from '../services/supabase/caretakersService';

export const RaiseBox = (props) => {

    const [statusMsg, setStatusMsg] = useState('');
    const [statusIsError, setStatusIsError] = useState(false);

    useEffect(() => {
        getCaretakersRaiseBox();
    }, [props.caretakerList])

    const getCaretakersRaiseBox = () => {
        var select = document.getElementById("caretakerSelectRaiseBox");
        select.innerHTML = '';
        for (const caretakerName of props.caretakerList) {
            var option = document.createElement("option");
            option.text = caretakerName.name;
            select.appendChild(option);
        }
    }

    const gatherFieldsRaiseBox = async () => {
        const caretakerReceivingRaise = document.getElementById("caretakerSelectRaiseBox").value;
        const raiseEffectiveDate = document.getElementById("dateOfRaise").value;
        const raiseEffectTime = new Date(raiseEffectiveDate).getTime();
        const newPay = parseFloat(document.getElementById("newPayRate").value);

        const caretakerIDEditRB = props.caretakerList.filter(e => e.name === caretakerReceivingRaise)[0].docID;

        try {
            await CaretakersService.updatePay(caretakerIDEditRB, newPay, raiseEffectTime);
            setStatusIsError(false);
            setStatusMsg("Pay updated successfully.");
        } catch (error) {
            console.error("Error updating pay:", error);
            setStatusIsError(true);
            setStatusMsg("Error updating caretaker pay.");
        }
    }

    return (
        <div className='raiseBoxDiv'>
            <a name='raiseBoxTarget' id='raiseBoxTarget'></a>
            <h2>Pay Rate Adustment</h2>

            <div className="formSep"></div>

            <div className="optionSelectDiv" id="caretakerDivRaiseBox">
                <label htmlFor="caretakerSelectRaiseBox">Caretaker to apply change to: </label>
                <select id="caretakerSelectRaiseBox"></select>
            </div>

            <div className="formSep"></div>

            <label htmlFor="dateOfRaise">Date change should take effect: </label>
            <input type="date" id="dateOfRaise"></input>

            <div className="formSep"></div>

            <label htmlFor="newPayRate">New pay rate: </label>
            <input type="number" id="newPayRate"></input>

            <div className="formSep"></div>

            <Button onClick={() => gatherFieldsRaiseBox()}
                type="button"
                buttonStyle="btn--success--solid"
                buttonSize="btn--medium"
            >
                Confirm Change
            </Button>
            {statusMsg && <p style={{color: statusIsError ? 'red' : 'green', marginTop: '8px'}}>{statusMsg}</p>}
        </div>
    )
}
